module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.sizeGridToDelete !== null) ? _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmação de Exclusão "), _c('strong', [_vm._v(_vm._s(this.sizeGridToDelete.code) + " - " + _vm._s(this.sizeGridToDelete.name))])]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n        Deseja remover a Guia de Medidas " + _vm._s(this.sizeGridToDelete.name) + "?\n        "), _c('span', [_vm._v("Apenas a remoção poderá ocorrer caso não aja nenhum projeto vinculado a mesma*")])]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Deletar")])])])]) : _vm._e(), _vm._v(" "), _c('list', {
    attrs: {
      "listTitle": _vm.$t('mercadoLivre.sizeGrids.label'),
      "loading": _vm.loading,
      "total": _vm.sizeGrids.length,
      "typesListAvailable": ['displayList'],
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'desc'
      }
    },
    on: {
      "change": _vm.submit,
      "clearFilters": _vm.clearFilters
    }
  }, [_c('span', {
    staticClass: "btn btn--info",
    attrs: {
      "slot": "header-actions"
    },
    on: {
      "click": _vm.createSizeGrid
    },
    slot: "header-actions"
  }, [_vm._v(_vm._s(_vm.$t('task.create.label')))]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Conta"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.account = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.identifier,
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v("\n            " + _vm._s(account.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 4,
      "label": "Gênero"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sem Gênero"
    }
  }, [_vm._v("Sem Gênero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Masculino"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Feminino"
    }
  }, [_vm._v("Feminino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Menino"
    }
  }, [_vm._v("Menino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Menina"
    }
  }, [_vm._v("Menina")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Domínio da tabela (tipo do produto)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productDomain),
      expression: "productDomain"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productDomain = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.productDomains), function(domain) {
    return _c('option', {
      key: domain,
      domProps: {
        "value": domain
      }
    }, [_vm._v("\n            " + _vm._s(domain) + "\n           ")])
  })], 2)])], 1), _vm._v(" "), _vm._l((_vm.sizeGrids), function(sizeGrid, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-12@md"
    }, [_c('size-grid-card', {
      attrs: {
        "sizeGrid": sizeGrid
      },
      on: {
        "getSizeGridToDelete": _vm.setSizeGridToDelete
      }
    })], 1)
  }), _vm._v(" "), (!_vm.sizeGrids.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhuma tabela de medidas encontrada\n      ")])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a9906b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SizeGrid/MercadoLivre/List.vue
// module id = 3314
// module chunks = 0